import Helpers from "@/helpers/Helpers";
import ConfigurationRoutes from "./configRoutes";
import ContentRoutes from "./contentRoutes";

import ContentView from "@/views/ContentView.vue";

export default {
  path: "/cms",
  component: Helpers.lazyLoad("CmsView"),
  children: [
    {
      path: "activity",
      name: "Activity",
      component: Helpers.lazyLoad("PtrSidebar"),
      meta: { requiresAuth: true }
    },
    {
      path: "home",
      name: "Home",
      component: Helpers.lazyLoad("HomeView"),
      meta: { requiresAuth: true }
    },
    {
      path: "content",
      name: "Content",
      // redirect: "/cms/content/clients/" + clientInternalIdentifier + "/sites",
      components: {
        default: ContentView
      },
      children: ContentRoutes,
      meta: { requiresAuth: true }
    },
    {
      path: "reports",
      name: "Reports",
      component: Helpers.lazyLoad("PtrSidebar"),
      meta: { requiresAuth: true }
    },
    {
      path: "analytics/:listItem?",
      name: "Analytics",
      component: Helpers.lazyLoad("AnalyticsView"),
      meta: { requiresAuth: true }
    },
    {
      path: "settings",
      name: "Config",
      redirect: "/cms/settings/metadata",
      component: Helpers.lazyLoad("SettingsView"),
      children: ConfigurationRoutes,
      meta: { requiresAuth: true }
    }
  ]
};
